var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatUpperIncisors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.7 109.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{font-size:10px;fill:#4d4d4d;font-family:SegoeUI-Semibold, Segoe UI;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cat_upper_incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_103",
    "data-name": 103,
    className: "cls-1",
    d: "M11.45,29.93c6.29-6.09,17.34-10,24.87-6.22,18.34,9.2,14.9,63.38,0,68.4C26.7,95.35,9.44,79,5.23,61,4.41,57.48.45,40.58,11.45,29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_102",
    "data-name": 102,
    className: "cls-1",
    d: "M82.85,11.28c-8.24-6.6-24.62-3.46-31.09,6.21-5.18,7.75-2.33,17.18,0,24.87C55.91,56.1,67.25,75.11,76.63,73.45,87,71.62,90.08,45.28,89.07,29.93,88.56,22.21,88,15.4,82.85,11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_101",
    "data-name": 101,
    className: "cls-1",
    d: "M127.78,7.41C121.19,0,105.32,0,97.62,7.54,91.46,13.61,92.53,22.61,93.4,30c1.56,13.12,9,32.25,18,32.4,10,.18,17.37-23,19-37C131.27,18.28,131.91,12,127.78,7.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_203",
    "data-name": 203,
    className: "cls-1",
    d: "M255,29.93c-6.29-6.09-17.33-10-24.87-6.22-18.34,9.2-14.9,63.38,0,68.4C239.8,95.35,257.05,79,261.26,61,262.09,57.48,266,40.58,255,29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_202",
    "data-name": 202,
    className: "cls-1",
    d: "M183.65,11.28c8.23-6.6,24.62-3.46,31.08,6.21,5.18,7.75,2.33,17.18,0,24.87-4.15,13.74-15.49,32.75-24.87,31.09-10.39-1.83-13.45-28.17-12.43-43.52C177.94,22.21,178.49,15.4,183.65,11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_201",
    "data-name": 201,
    className: "cls-1",
    d: "M138.71,7.41c6.6-7.39,22.47-7.45,30.16.13C175,13.61,174,22.61,173.09,30c-1.56,13.12-9,32.25-18,32.4-10,.18-17.37-23-19-37C135.22,18.28,134.58,12,138.71,7.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "numbering"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(27.67 107.21)"
  }, "103"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(68.49 89.94)"
  }, "102"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(106.16 77.53)"
  }, "101"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(144.72 77.65)"
  }, "201"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(179.11 89.82)"
  }, "202"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(220.64 107.21)"
  }, "203"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatUpperIncisors);
export default __webpack_public_path__ + "static/media/cat_upper_incisors.8c5e0015fbc347e085d9f96b5171c569.svg";
export { ForwardRef as ReactComponent };